import { ShadowBox } from 'components/ShadowBox'
import React, { PropsWithChildren } from 'react'
import { isMobile } from 'react-device-detect'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { Me, Usage } from 'service/user'
import { FormValues } from 'utils/type'
import { TextArea } from './TextArea'
import { Input } from 'components/atom/Input'
import { PRODUCT_NAME_PATTERN } from '../util'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { UserType } from 'utils/common'

interface ErrorType {
  products: {
    link: boolean
    product: boolean
  }[]
  mainTitle: boolean
  thumbnail: boolean
}
interface YoutubeTitleProps {
  watch: UseFormWatch<FormValues>
  control: Control<FormValues, any>
  setValue: UseFormSetValue<FormValues>
  userInfo: Me
  clipTitleIsPending: boolean
  thumbnailIsPending: boolean
  aiRecommendClipTitle: string[] | null
  mainTitleInputRef: React.MutableRefObject<HTMLInputElement | null>
  setError: React.Dispatch<React.SetStateAction<ErrorType>>
  error: ErrorType
  usage: Usage | undefined
}

export const YoutubeTitle = ({
  watch,
  control,
  setValue,
  userInfo,
  clipTitleIsPending,
  thumbnailIsPending,
  aiRecommendClipTitle,
  mainTitleInputRef,
  setError,
  error,
  usage,
}: PropsWithChildren<YoutubeTitleProps>) => {
  return (
    <ShadowBox className="relative py-[40px] md:w-[816px]">
      {watch('products.0.link') === '' && (
        <div className="absolute left-0 z-50 h-full w-full bg-white px-[16px] py-[40px] opacity-50 md:w-[816px]"></div>
      )}
      <div className="flex w-full flex-col gap-[16px]">
        <div className="flex flex-col items-center">
          <h3 className="text-[24px] font-bold text-[#2E343D]">
            유튜브 영상용 제목 입력
          </h3>
          <p className="text-[14px] text-main">매력적인 내용을 정해주세요!</p>
        </div>
        <div className="px-4 md:px-0">
          <span className="mb-2 flex h-[22px] w-[65px] items-center justify-center rounded-[4px] bg-[#2E343D] text-[12px] font-bold text-white">
            <StarIcon className="text-white" /> AI 생성
          </span>
          {clipTitleIsPending || thumbnailIsPending ? (
            <>
              <div className="flex flex-col gap-1">
                {new Array(5).fill(0).map((el, index) => (
                  <div className="relative h-[20px] w-full" key={index}>
                    <div className="absolute inset-0 overflow-hidden bg-gray-300">
                      <div className="h-full w-full animate-skeleton bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300"></div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              {' '}
              {aiRecommendClipTitle?.map((el) => (
                <>
                  <button
                    className="mt-1 flex rounded-[6px] bg-[#EEF1F7] px-2 py-1 text-left hover:bg-[#BBEBEC]"
                    type="button"
                    onClick={() => {
                      setValue('mainTitle', el)
                    }}
                  >
                    {el}
                  </button>
                </>
              ))}
            </>
          )}
        </div>
        <div className="flex w-full flex-col items-center gap-[8px] md:w-[736px]">
          <div className="relative">
            <Controller
              key="mainTitle"
              render={({ field }) => (
                <>
                  {isMobile ? (
                    <>
                      {' '}
                      <TextArea
                        inputRef={mainTitleInputRef}
                        error={error.mainTitle}
                        disabled={
                          usage &&
                          !usage?.available &&
                          userInfo?.userType !== UserType.체험
                        }
                        {...field}
                        placeholder="유튜브 영상용 제목 입력 (90자 이하)"
                        maxLength={90}
                      />
                    </>
                  ) : (
                    <Input
                      inputRef={mainTitleInputRef}
                      error={error.mainTitle}
                      disabled={
                        usage &&
                        !usage?.available &&
                        userInfo?.userType !== UserType.체험
                      }
                      {...field}
                      placeholder="유튜브 영상용 제목 입력 (90자 이하)"
                      maxLength={90}
                    />
                  )}
                  <div
                    className={`mt-[8px] flex gap-[4px] ${
                      (field.value.length > 90 ||
                        !PRODUCT_NAME_PATTERN.test(field.value)) &&
                      'text-error'
                    }`}
                  >
                    <span>{field.value.length}/90</span>
                    <span>{`이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.`}</span>
                  </div>
                </>
              )}
              name={'mainTitle'}
              rules={{
                required: {
                  value: true,
                  message: '유튜브 영상 제목은 필수입니다!',
                },
                maxLength: {
                  value: 90,
                  message: '유튜브 영상 제목의 길이가 90자를 넘습니다.',
                },
                validate: (value) => {
                  const updateError = { ...error }
                  updateError.mainTitle = false
                  setError(updateError)
                  return (
                    PRODUCT_NAME_PATTERN.test(value) ||
                    '이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.'
                  )
                },
              }}
              control={control}
            />
          </div>
        </div>
      </div>
    </ShadowBox>
  )
}
